import { render, staticRenderFns } from "./WebEditor.vue?vue&type=template&id=b11ab52a"
import script from "./WebEditor.vue?vue&type=script&lang=js"
export * from "./WebEditor.vue?vue&type=script&lang=js"
import style0 from "./WebEditor.vue?vue&type=style&index=0&id=b11ab52a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports